module.exports = __webpack_public_path__ + "img/blue.9509b133.png";